import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { SettingsOpsService } from '../../settings-ops/settings-ops.service';
import { GtwSnackbarService } from '../../../../shared/_services/gtw-snackbar.service';
import { SettingsTab } from '../system-settings.component';

@Component({
    selector: 'gtw-create-settings-modal',
    templateUrl: './create-settings-modal.component.html',
    styleUrls: ['./create-settings-modal.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CreateSettingsModalComponent implements OnDestroy {
  title = 'Create New Setting';
  name = '';
  value = '';
  loading = false;
  minimise = false;

  private settingType: SettingsTab;
  private baseUrl: string;
  private client: any;
  private appKey: string;
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<CreateSettingsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private settingsOpsService: SettingsOpsService,
    private snackbar: GtwSnackbarService,
  ) {
    this.title = data?.title || 'Create New Setting';
    this.settingType = data?.settingType || 'configSettings';
    this.baseUrl = data?.baseUrl || '';
    this.client = data?.client || {};
    this.appKey = data?.appKey ?? '';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  saveSettings(): void {
    if (!this.name) {
      this.snackbar.openSnackBar('Name is required', 'gtw-snackbar--yellow');
      return;
    }
    this.loading = true;
    const payload: any = {
      key: this.name,
      value: this.value,
      clientKey: this.client?.client_key ?? '',
      clientDatasource: this.client?.client_datasource ?? '',
      appKey: this.appKey ?? '',
    };

    const req =
      this.settingType === 'appconfigSettings'
        ? this.settingsOpsService.saveAppSetting(this.baseUrl, payload)
        : this.settingType === 'clientconfigSettings'
          ? this.settingsOpsService.saveClientSetting(this.baseUrl, payload)
          : this.settingsOpsService.saveSystemSetting(this.baseUrl, payload);

    req.pipe(takeUntil(this.destroy$)).subscribe({
      next: (resp: any) => {
        this.loading = false;
        if (String(resp?.callSuccess) === '1') {
          this.snackbar.openSnackBar('Setting saved successfully.', 'gtw-snackbar--green');
          this.dialogRef.close('saved');
        } else {
          this.snackbar.openSnackBar(resp?.p_error_out || 'Save failed', 'gtw-snackbar--red');
        }
      },
      error: () => {
        this.loading = false;
        this.snackbar.openSnackBar('Error occurred while saving setting', 'gtw-snackbar--red');
      },
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
